var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "info-item-wrapper" }, [
    _c("div", { staticClass: "row header" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("info-ceckbox", {
            attrs: { label: _vm.label, value: _vm.isEnabled },
            on: {
              input: function($event) {
                return _vm.$emit("set-enabled", $event)
              }
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row body",
        class: { "disabled-overlay": !_vm.isEnabled }
      },
      [_c("div", { staticClass: "col-12" }, [_vm._t("default")], 2)]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }